import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { PostHogProvider } from '@posthog/react'
import './index.css'
import App from './App.tsx'

async function enableMocking() {
  // Disabled MSW to use real backend API
  // if (import.meta.env.DEV) {
  //   const { worker } = await import('./services/mock/browser')
  //   return worker.start({
  //     onUnhandledRequest: 'bypass',
  //   })
  // }
}

const posthogOptions = {
  api_host: import.meta.env.VITE_PUBLIC_POSTHOG_HOST,
  ui_host: 'https://us.posthog.com',
  defaults: '2026-01-30',
} as const

enableMocking().then(() => {
  createRoot(document.getElementById('root')!).render(
    <StrictMode>
      <PostHogProvider
        apiKey={import.meta.env.VITE_PUBLIC_POSTHOG_KEY}
        options={posthogOptions}
      >
        <App />
      </PostHogProvider>
    </StrictMode>,
  )
})
